import { useEffect, useRef, useState } from 'react';
import '../App.css';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import * as UI from '../slices/uiSlice';
import { AnyAction } from 'redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { getTitle } from '../App';
import logo from '../assets/PLS_Primary_Logo_on_dark.png';
import hub_logo from '../assets/Main_Hub_Icon_Large.svg';
import burger_svg from '../assets/Burger_Menu.svg';
import LogoutIcon from '../assets/logout-icon.svg';
import UserProfile from '../assets/user-profile.svg';
import ChevronDownIcon from '../assets/chevron-down-icon.svg';

const NavBar = () => {
	const location = useLocation();
	const userState = useAppSelector(state => state.user);
	const quotes = useAppSelector(state => state.quotes);
	const cases = useAppSelector(state => state.cases);
	const [showLogoutModal, setshowLogoutModal] = useState<boolean>(false);
	const logoutModalRef = useRef<HTMLDivElement | null>(null);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	const toggleMenu = () => {
		dispatch((UI.toggleMenu()) as unknown as AnyAction);
	}

	let title: string = (location.pathname === '/quote' && quotes.quote.quoteid === '' ? 'Get a Quote' : getTitle(location.pathname));
	if (location.pathname === '/case' || location.pathname === '/team' || location.pathname === '/actions') {
		title = title + ' - [' + cases.case.caseno + ']';
	}

	useEffect(() => {
		const handler = (e: MouseEvent | TouchEvent): void => {
			if (logoutModalRef.current && !logoutModalRef.current?.contains(e.target as Node)) {
				setshowLogoutModal(false);
			}
		};

		document.addEventListener('mousedown', handler);
		document.addEventListener('touchstart', handler);
		return () => {
			document.removeEventListener('click', handler);
			document.removeEventListener('mousedown', handler);
		};
	}, []);

	return (
		<div className="NavBar">
			<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', display: 'flex' }}>
				<div style={{ zIndex: 999 }}>
					<img style={{ width: 128 }} src={logo} alt='PLS-Logo' />
				</div>

				<div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
					<div className="padding8" onClick={() => toggleMenu()}>
						<img style={{ width: 24, marginLeft: 32 }} src={burger_svg} alt='Burger-Icon' />
					</div>
				</div>

				<div style={{ display: 'flex', alignItems: 'center', flex: '1 1 0px', justifyContent: 'flex-end' }}>
					{!cases.isLoaded &&
						<div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
							<div style={{ display: 'flex', flex: '1 1 0px', justifyContent: 'space-between', alignItems: 'center' }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 16, marginRight: 8 }}>Loading</div>
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							</div>
						</div>
					}

					{cases.isLoaded &&
						<div style={{ display: 'flex', alignItems: 'center', overflow: 'hidden', cursor: 'pointer' }} onClick={() => navigate('/hub')}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<img style={{ width: 48, marginRight: 8 }} src={hub_logo} alt='Hub-Logo' />
								<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', fontFamily: 'OpenSans-Bold', fontSize: 16 }}>Main Hub</div>
							</div>
						</div>
					}
				</div>

				<div style={{ marginLeft: '64px', display: 'flex', alignItems: 'center', gap: '12px', position: 'relative' }}>
					<img src={UserProfile} alt="User-Profile" style={{ height: 40, width: 40, borderRadius: '50%' }} />

					<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
						<p style={{ color: '#FFFFFF', fontSize: '18px', fontFamily: 'OpenSans-Bold' }}>{userState.user}</p>

						<div style={{ height: '20px', width: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', border: '2px solid #FFFFFF', borderRadius: '50%', cursor: 'pointer' }} onClick={() => setshowLogoutModal(!showLogoutModal)}>
							<img src={ChevronDownIcon} alt="ChevronDown-Icon" style={{ height: 16, width: 16, rotate: (showLogoutModal ? '180deg' : '0deg'), transition: 'all 0.3s ease' }} />
						</div>
					</div>

					{showLogoutModal && <div style={{ position: 'absolute', top: '75px', right: '0px', padding: '20px', backgroundColor: '#FFFFFF', borderRadius: '5px', zIndex: '5' }} ref={logoutModalRef}>
						<p style={{ color: '#222222', fontSize: '16px', textAlign: 'right', margin: '0px' }}>{userState.user}</p>
						<p style={{ color: '#7C7C7C', fontSize: '16px', textAlign: 'left', margin: '5px 0px 0px 0px' }}>({userState.id})</p>

						<div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '30px', cursor: 'pointer' }} onClick={() => navigate('/logout')}>
							<img src={LogoutIcon} alt="Logout-Icon" style={{ height: 20, width: 20 }} />
							<p style={{ color: '#EA0000', fontSize: '14px', fontWeight: '600', textTransform: 'uppercase', margin: '0px' }}>Logout</p>
						</div>
					</div>}
				</div>
			</div>
		</div>
	);

}

export default NavBar;